import React,{Component} from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from '@material-ui/core/TextField';

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Grid from '@material-ui/core/Grid';
//import Checkbox from '@material-ui/core/Checkbox';

class Moratorium extends Component {
    constructor(props) {

        super(props);
        this.state = {
            selValue: '',
            moratoriumList:{
                capital:false,
                interest:false,
                capital_interest:false
            },
        }

    }
    handleRadioChange = (e) => {
        this.setState({ selValue: e.target.name });
        this.handleList(e.target.name)
        
    };
    handleChange =(e)=>{
        this.props.handleChange(e)
    }
    handleMoratoriumValChange =(e)=>{
        this.props.handleMoratoriumValChange(e)
    }
    
     handleList = (value) => {
        let moratoriumListCopy = JSON.parse(JSON.stringify(this.state.moratoriumList))
    
        if (value === 'capital') {
            moratoriumListCopy['capital'] = true
            moratoriumListCopy['interest'] = false
            moratoriumListCopy['capital_interest'] = false
        
        } else if (value === 'interest') {
            moratoriumListCopy['capital'] = false
            moratoriumListCopy['interest'] =true
            moratoriumListCopy['capital_interest'] = false

        } else {
            moratoriumListCopy['interest'] =false
            moratoriumListCopy['capital'] = false
            moratoriumListCopy['capital_interest'] = true

        }

        this.setState({
            moratoriumList:moratoriumListCopy 
        })

       this.props.handleMoratoriumRadioChange(moratoriumListCopy);
      };
    render() {
        const  val = this.state.val
        return (
            <>
                <RadioGroup value={val} onChange={(e) => this.handleRadioChange(e)}>

                    <FormControlLabel
                        control={<Radio color="primary" name="capital" />}
                        label="To pay interest only"
                        value='capital'
                       
                    // onChange={(e) => props.handleChange(e)}
                    />

{/* 
                    <FormControlLabel
                        control={<Radio color="primary" name="interest" />}
                        label="To Pay Capital only"
                        value='interest'
                    /> */}

                    <FormControlLabel
                        control={<Radio color="primary" name="capital_interest" />}
                        label="To grant Debt Deferment (Capital+Interest)"
                        value='capital_interest'
                    //onChange={(e) => props.handleChange(e)}
                    />
                </RadioGroup>
                <Grid item xs={12} sm={6}>
                <TextField
                    variant="outlined"
                    required
                    fullWidth
                    type="number"
                    id="moratoriumMonths"
                    label="Period in Months"
                    name="moratoriumMonths"
                    //InputProps={{ inputProps: { min: 0, max: 60 } }}
                    // onInput={(e) => {
                    //     e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 2)
                    // }}
                    // type="number"
                    autoComplete="moratoriumMonths"
                    onKeyPress={(e) => {
                        e.key === "-"  && e.preventDefault();
                        e.key === "e"  && e.preventDefault();
                      }}
                    onChange={(e) => {
                        if (e.target.value.length > 2) {
                            e.target.value = e.target.value.slice(0, 2);
                        }
                        this.handleMoratoriumValChange(e)
                    }}
                   // onChange={(e) => this.handleMoratoriumValChange(e)}
                />
                    </Grid>
            </>
        )
    }
}
export default Moratorium;